import { SAME_ORIGIN_IFRAME_COMM_CHANNEL_ID } from "./constants";
export function genIframeContent(scriptAbsUrl, containerClassName, containerId, debug, extraData, nonce) {
    const serializedExtraData = JSON.stringify(extraData);
    const nonceAttr = nonce ? ` nonce="${nonce}"` : '';
    return `
<!DOCTYPE html>
<html>
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style${nonceAttr}>
            body {
                margin: 0;
                padding: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
                width: 100vw;
                overflow: hidden;
            }
        </style>
        <script type="module"${nonceAttr}>
            (async () => {
                const isDebugMode = ${String(!!debug)};

                window.__SAME_ORIGIN_IFRAME_EXTRA_DATA__ = ${serializedExtraData};

                const LOG_CONTEXT = 'SAME-ORIGIN-IFRAME-CHILD:';
                const logger = {
                    info: (...args) => {
                        if (isDebugMode) {
                            console.info(LOG_CONTEXT, ...args);
                        }                
                    },
                    error: (...args) => {
                        // Always log errors, even in production
                        console.error(LOG_CONTEXT, ...args);
                    }
                };

                function sendMessageToParent(type, data = null) {
                    if (!window.parent) {
                        logger.info('No parent window found');
                        return;
                    }
                    window.parent.postMessage({
                        channel: '${SAME_ORIGIN_IFRAME_COMM_CHANNEL_ID}',
                        type,
                        data,
                    }, window.location.origin);
                    logger.info('New event sent: ', type, data);
                }

                function sendErrorMessage(error) {
                    const errMessage = error instanceof Error
                        ? error.message
                        : String(error);
                    
                    sendMessageToParent('error', { errMessage });
                }

                try {
                    const scriptUrl = '${scriptAbsUrl}';
                    await import(scriptUrl);
                    sendMessageToParent('script-loaded', { scriptUrl });
                } catch (err) {
                    logger.error('Import error:', err);
                    sendErrorMessage(err);
                }
            })();
        </script>
    </head>
    <body>
        <div class="${containerClassName}" id="${containerId}" style="width: 100%; height: 100%;"></div>
    </body>
</html>
`;
}
//# sourceMappingURL=iframe-content.js.map